import { Database, Settings, Shield, Users } from 'lucide-react';
import { NavLink, Outlet } from 'react-router-dom';

const TABS = [
    { to: '/admin', end: true, label: "Vue d'ensemble", icon: Shield },
    { to: '/admin/utilisateurs', end: false, label: 'Utilisateurs', icon: Users },
    { to: '/admin/sauvegardes', end: false, label: 'Sauvegardes', icon: Database },
    { to: '/admin/parametres', end: false, label: 'Paramètres', icon: Settings },
];

/** Coquille du back-office.
 *
 *  Le tiroir latéral ne porte qu'une entrée « Admin » : c'est l'écran qu'on
 *  ouvre d'une main en marchant, et trois lignes d'administration y noyaient
 *  les quatre entrées qui servent vraiment. Les sous-sections vivent donc ici,
 *  sous des onglets — et il y a de la place pour en ajouter sans toucher au
 *  tiroir. */
export function AdminLayout() {
    return (
        <div className="py-2">
            <header className="mb-4">
                <h1 className="text-2xl font-bold tracking-tight">Administration</h1>
                <p className="mt-1 text-sm opacity-60">
                    Réservé aux administrateurs. Chaque appel est revérifié côté serveur.
                </p>
            </header>

            {/* Les onglets se partagent la largeur au lieu de déborder. À
                390 px, « Paramètres » sortait de l'écran : la barre défilait
                bien, mais rien ne le laissait deviner — un onglet à moitié
                visible se lit comme un onglet manquant. Les icônes ne
                réapparaissent qu'à partir de sm, où la place existe. */}
            <div role="tablist" className="tabs tabs-box mb-5 flex-nowrap">
                {TABS.map(({ to, end, label, icon: Icon }) => (
                    <NavLink
                        key={to}
                        to={to}
                        end={end}
                        role="tab"
                        className={({ isActive }) =>
                            `tab flex-1 gap-2 whitespace-nowrap ${isActive ? 'tab-active' : ''}`}
                    >
                        <Icon size={16} className="hidden sm:inline" aria-hidden="true" />
                        {label}
                    </NavLink>
                ))}
            </div>

            <Outlet />
        </div>
    );
}
